import {
    SCORE_BOOM_CARD,
    SCORE_JOKER_BOOSTER,
    SCORE_JOKER_PRE_BOOSTER,
    SCORE_KEY_CARD,
    SCORE_LOCK_CARD,
    SCORE_PLUS_THREE_CARD,
    SCORE_SCISSOR_CARD,
    SCORE_ROCK_CARD,
    SCORE_TORNADO_CARD,
    SCORE_VALUE_CARD,
    SCORE_SCYTHE_CARD,
    SCORE_PLINKO_CARD,
} from 'Constants/Score';
import { CardType } from './CardType';

type tCardScoreMap = {
    [K in CardType]: number;
};
export const CardScoreMap: tCardScoreMap = {
    [CardType.boom]: SCORE_BOOM_CARD,
    [CardType.canister_pre_booster]: SCORE_BOOM_CARD,
    [CardType.gold]: 0,
    [CardType.joker]: SCORE_JOKER_BOOSTER,
    [CardType.joker_pre_booster]: SCORE_JOKER_PRE_BOOSTER,
    [CardType.key]: SCORE_KEY_CARD,
    [CardType.lock]: SCORE_LOCK_CARD,
    [CardType.plus_three]: SCORE_PLUS_THREE_CARD,
    [CardType.scissors]: SCORE_SCISSOR_CARD,
    [CardType.rock]: SCORE_ROCK_CARD,
    [CardType.tornado]: SCORE_TORNADO_CARD,
    [CardType.value]: SCORE_VALUE_CARD,
    [CardType.zap]: SCORE_SCYTHE_CARD,
    [CardType.plinko]: SCORE_VALUE_CARD,
};
